/**
 * Tenant Management API Service
 * 
 * Handles all API calls related to tenant management, customization, and configuration
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  // Tenant information
  TENANT_INFO: '/api/v1/ux/tenant-info',
  
  // Theme management
  THEMES: '/api/v1/ux/themes/current',
  THEME_BY_TENANT: (tenantId) => `/api/v1/ux/themes/${tenantId}`,
  
  // UX customization
  UX_CUSTOMIZATION: '/api/v1/ux',
  LOGOS: '/api/v1/ux/logos',
  LOGO_BY_TENANT: (tenantId, logoType = 'primary') => `/api/v1/ux/logos/${tenantId}?type=${logoType}`,
  
  // Tenant management
  TENANTS: '/api/v1/tenants',
  TENANT_BY_ID: (tenantId) => `/api/v1/admin/developer/tenant/${tenantId}`,
  
  // Feature flags
  FEATURE_FLAGS: '/api/v1/config/feature-flags',
  FEATURE_FLAGS_BY_TENANT: (tenantId) => `/api/v1/features/tenant/${tenantId}/features`,
};

/**
 * Tenant Management API functions
 */
export const tenantManagementService = {
  // Tenant information
  getTenantInfo: () => {
    console.log('Fetching tenant info...');
    return api.get(ENDPOINTS.TENANT_INFO);
  },
  
  // Theme management
  getTheme: (tenantId) => api.get(ENDPOINTS.THEME_BY_TENANT(tenantId)),
  updateTheme: (tenantId, themeConfig) => api.post(ENDPOINTS.THEME_BY_TENANT(tenantId), themeConfig),
  
  // Logo management
  getLogo: (tenantId, logoType = 'primary') => api.get(ENDPOINTS.LOGO_BY_TENANT(tenantId, logoType), {
    responseType: 'blob' // Important for binary data
  }),
  uploadLogo: (tenantId, logoFile, logoType = 'primary') => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    formData.append('logo_type', logoType);
    
    return api.post(ENDPOINTS.LOGO_BY_TENANT(tenantId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  deleteLogo: (tenantId, logoType = 'primary') => api.delete(ENDPOINTS.LOGO_BY_TENANT(tenantId, logoType)),
  
  // Tenant management
  getTenants: (params) => api.get(ENDPOINTS.TENANTS, { params }),
  getTenantById: (tenantId) => api.get(ENDPOINTS.TENANT_BY_ID(tenantId)),
  createTenant: (tenantData) => api.post(ENDPOINTS.TENANTS, tenantData),
  updateTenant: (tenantId, tenantData) => api.put(ENDPOINTS.TENANT_BY_ID(tenantId), tenantData),
  deleteTenant: (tenantId) => api.delete(ENDPOINTS.TENANT_BY_ID(tenantId)),
  
  // Feature flags
  getFeatureFlags: (tenantId) => api.get(ENDPOINTS.FEATURE_FLAGS_BY_TENANT(tenantId)),
  updateFeatureFlag: (tenantId, flagKey, enabled) => api.post(ENDPOINTS.FEATURE_FLAGS_BY_TENANT(tenantId), {
    flag_key: flagKey,
    enabled
  }),
}; 